import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { DocumentTemplateQuery } from '@/gql/graphql';

const GET_DOCUMENT_TEMPLATE = graphql(`
  query DocumentTemplate($id: ID!) {
    documentTemplate(id: $id) {
      id
      name
      description
      templateHtml
      usedVariables
      previewDummyDocumentInstance {
        documentHtml
      }
      expectedSignatories {
        role
        identifier
      }
      chatAgentConversation {
        id
      }
    }
  }
`);

export type DocumentTemplate = NonNullable<
  DocumentTemplateQuery['documentTemplate']
>;

const useGetDocumentTemplate = (id?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!id,
    queryKey: meKeys.accountDocumentTemplate(id!),
    queryFn: () =>
      gqlClient.request(GET_DOCUMENT_TEMPLATE, {
        id: id!,
      }),
  });
  return {
    documentTemplate: data?.documentTemplate,
    data,
    ...rest,
  };
};

export default useGetDocumentTemplate;
